export enum VerificationRequestPolicy {
  CannotRequestVerification = "CannotRequestVerification",
  CanRequestVerification = "CanRequestVerification",
  VerificationRequired = "VerificationRequired",
}

export interface VerificationRequestPolicyOption {
  label: string;
  value: VerificationRequestPolicy;
}

export const VERIFICATION_REQUEST_POLICY_OPTIONS: VerificationRequestPolicyOption[] =
  [
    {
      label: "Cannot Request Verification",
      value: VerificationRequestPolicy.CannotRequestVerification,
    },
    {
      label: "Can Request Verification",
      value: VerificationRequestPolicy.CanRequestVerification,
    },
    {
      label: "Verification Required",
      value: VerificationRequestPolicy.VerificationRequired,
    },
  ];
